<template>
<div :class="{bgred:isbackgrounds,tcolor:iscolors,fixheader:true,bgfff:isbgff,boxshow:isboxshow}">
  <div class="wrap">
    <!--  log-->
    <div class="logo">
<!--      <img src="../../assets/logo.png" v-if="islogoreds"/>-->
      <img src="../../assets/logored.png"/>
    </div>
    <nav>
      <span v-for="item in navtitle" :key="item.title">
          <span @click="navclick(item)" :class="{action:item.name===isnavtext,navtitle}" v-if="!item.children">{{item.name}}</span>
<!--          悬浮时弹出框-->
          <el-popover
              v-else
              :show-arrow="false"
              :offset="0"
              :popper-style="popperStyles"
              trigger="hover"
              @show="item.popoverVisible = true"
              @hide="item.popoverVisible = false"
          >
            <template #reference>
              <span :class="{action:item.name===isnavtext,navtitle}" style="padding-right: 0">
                {{item.name}}
                 <img
                     src="../../assets/head/top-xl.png"
                     v-if="!item.popoverVisible"
                 >
                 <img
                     src="../../assets/head/top-xlon.png"
                     v-else
                 >
              </span>
            </template>
            <template #default>
              <el-row>
                <!-- 左侧固定列：背景、标题、服务热线 -->
                <el-col
                    :span="5"
                    style="background: #f4f4f4; padding: 1.5rem; box-sizing: border-box;"
                >
                  <div style="display: flex; flex-direction: column; gap: 6rem;">
                    <div style="font-size: 2rem; font-weight: 600; color: #333333;margin-left: 6rem;margin-top: 20%">
                      {{ item.name }}
                      <img src="../../assets/head/xy.png" style="vertical-align: middle; margin-bottom: 0.4rem;"/>
                    </div>
                    <div style="margin-bottom: 20%">
                      <div style="color: #333333; font-size: 1.4rem; margin-bottom: 0.5rem;margin-left: 5rem;font-weight: 500">服务热线：</div>
                      <div style="color: red; font-size: 1.4rem;margin-left: 5rem;">{{ company.businessHotline }}</div>
                    </div>
                  </div>
                </el-col>
                <!-- 右侧动态列：循环渲染 item.children -->
                <el-col :span="19" style="padding: 1.5rem; box-sizing: border-box; display: flex; flex-wrap: wrap;">
                  <div
                      v-for="(child, index) in item.children"
                      :key="index"
                      style="color: #333333;width: 25%; padding: 2rem 0 0 6rem; cursor: pointer; font-size: 1.4rem;font-weight: 600"
                      @click="handleChildClick(child, item)"
                  >
                    {{ child.chName ? child.chName : child.title }}
                  </div>
                </el-col>
              </el-row>
            </template>
          </el-popover>
      </span>
    </nav>
    <div class="ewlink">
      <span v-for="(item,index) in ewlinkData" :key="index" @click="openlinke(item)" :class="{action:item.name===isnavtext,navtitle}">{{item.name}}</span>
<!--      :src="require('../../../assets/'+item.url)"-->

    </div>
      <img :src="telephoneimg" style="height: 1.6rem;position: relative; top: 25px; margin-right: 10px; margin-left: 20px">
      <span style="color: red;font-size: 20px;margin-left: -4px;">{{ company.businessHotline }}</span>
    <el-dropdown v-if="this?.$TOOL?.data?.get('USER_INFO')" class="user-dropdown" trigger="click" @command="handleCommand" style="height: 1.6rem;position: relative; top: 25px; margin-right: 10px; margin-left: 20px">
      <div class="user-info">
        <el-avatar :size="40" :src="user.avatar" />
        <span class="user-name">{{ user.name }}</span>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="profile">
            个人主页
          </el-dropdown-item>
          <el-dropdown-item command="logout" divided>
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <el-button
        v-else
        type="primary"
        @click="login()"
        style="width: 5rem;height: 5rem;border-radius: 50%;background-color: #FF0B41;
          border-color: #FF0B41;font-size: 2.8rem;color: #fff;margin-left: 1rem;display: flex;
          align-items: center;justify-content: center;box-shadow: 0 2px 8px rgba(255, 11, 65, 0.3);margin-top: 0.8rem;"
    >
      登录
    </el-button>
  </div>
</div>
</template>

<script>
import {mapState} from  'vuex'
import newService from "@/api/newService";
import config from "@/config";

export default {
  name: "headerIndex",
  props:{
    // 背景颜色
    'isbackground':{
      type:Boolean,
      default:false
    },
    // 字体颜色
    'iscolor':{
      type:Boolean,
      default:false
    },
    // logo颜色
    'islogored':{
      type:Boolean,
      default:false
    },
    company:{
        type: Object,
        default(){
            return {}
        }
    }
  },
  data(){
    return {
      popperStyles: {
        padding: 0,
        width: '140rem', // 宽度=wrap 宽度
        left: '0', // 初始左偏移（后续动态更新为 wrap 的左侧位置）
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)' // 优化阴影
      },
      user: {
        name: "", // 实际应用中应从Vuex或API获取
        avatar: '/favicon.ico' // 默认头像
      },
      timer:null,
      telephoneimg:require('../../assets/tb-dh1.png'),
      // 背景颜色
      isbackgrounds:false,
      isbgff:false,
     // 字体颜色
      iscolors:false,
      // logo颜色
      islogoreds:false,
      //底部阴影
      isboxshow:false,
//点击的文字
      isnavtext:'首页',
      // nav显示的文字
      navtitle:[
        {
          name:'首页',
          title:'home'
        },
        {
          name:'产品',
          title:'product',
          children:[],
          popoverVisible:false
        },
        {
          name:'方案',
          title:'programme',
          children:[],
          popoverVisible:false
        },
        {
          name:'生态',
          title:'ecology'
        },
        // {
        //   name:'云仓',
        //   title:'Yuncang'
        // },
        // {
        //   name:'服务',
        //   title:'service'
        // },
        {
          name:'关于',
          title:'about'
        }
      ],
      //额外的链接
      ewlinkData:[
        {
          name:'云仓',
          title:'Yuncang'
        },
        // {
        //   name:'产品体验',
        //   title:'productExperience'
        // },
        {
          name:'论坛',
          title:'forum'
        },
        {
          name:'帮助文档',
          link:''
        },
        // {
        //   name:'用户社区',
        //   link:''
        // }
      ],
      pageNum:1,
      pageSize:9999,
    }
  },
  watch:{
    'isbackground'(){
      this.isbackgrounds=this.isbackground
    },
    'iscolor'(){
      this.iscolors=this.iscolor
    },
    'islogored'(){
      this.islogoreds=this.islogored
    },
    '$store.state.components'(){
      let stname=this.$store.state.components
      let linkname=this.navtitle.filter(item=>item.title===stname)
      if(linkname.length!==0){
        this.isnavtext=linkname[0].name
      }
    },
    '$store.state.userName'(newName,oldName){
        if(newName!==oldName){
          this.user.name=newName
        }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrolling);
    clearInterval(this.timer);
    let num=1
    let that=this
    this.timer = setInterval(function () {
      if(num===4){
        num=1
      }else{
        num++
      }
      that.telephoneimg=require('../../assets/tb-dh'+num+'.png')
    },300);
    if (this?.$TOOL?.data?.get('USER_INFO')){
        this.user.name =this?.$TOOL?.data?.get('USER_INFO').name
    }else {
        newService.getYouKeNameByIp().then((res) => {
            console.log(res)
            this.user.name = res
        })
    }
    this.getProductsList();
    this.getPlanList();
    // 新增：初始化时计算 wrap 位置，更新弹窗左偏移
    this.calcWrapPosition();
    // 补充：滚动时重新计算（防止窗口缩放/滚动导致位置偏移）
    window.addEventListener("resize", this.calcWrapPosition); // 窗口缩放时
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.calcWrapPosition);
  },
  created() {
  },
  computed:{
    ...mapState(['components'])
  },
  methods:{
    handleChildClick(child,item){
      if (item.name === '产品'){
        this.goToProduct4(child.id)
      }else {
        this.goToProgramme1(child.id);
      }
    },
    goToProduct4(id){
      this.$store.state.productId=id
      this.$store.state.components='product4'
      this.$store.state.isbackground=false
      this.$store.state.iscolor=true
      this.$store.state.islogored=true
      document.body.scrollTop=document.documentElement.scrollTop=0
    },
    goToProgramme1(id){
      this.$store.state.planId=id
      this.$store.state.components='programme1'
      this.$store.state.isbackground=true
      this.$store.state.iscolor=true
      this.$store.state.islogored=true
      document.body.scrollTop=document.documentElement.scrollTop=0
    },
    // 新增：计算 wrap 的左侧偏移量，更新 popperStyles.left
    calcWrapPosition() {
      const wrapEl = document.querySelector('.wrap'); // 获取 wrap 元素
      if (wrapEl) {
        // 获取 wrap 距离页面左侧的偏移量（px），赋值给弹窗左偏移
        this.popperStyles.left = `${wrapEl.offsetLeft}px`;
      }
    },
    getProductsList(){
      var obj={
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      newService.getProductsList(obj).then((res)=>{
        this.navtitle.find(item => item.name === '产品').children=res.rows
      })
    },
    getPlanList(){
      var obj={
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      newService.getPlanList(obj).then((res)=>{
        this.navtitle.find(item => item.name === '方案').children=res.rows
      })
    },
    handleCommand(command) {
      if (command === 'profile') {
        this.openlinke({name:'个人主页', title:'personProfile'})
      } else if (command === 'logout') {
        this.logout(); // 执行退出登录
      }
    },
    login(){
      this.$router.push('/login')
    },
    logout() {
        // 实际退出登录逻辑
        this.$confirm("确认是否退出当前用户？", "提示", {
            type: "warning",
            confirmButtonText: "退出",
            confirmButtonClass: "el-button--danger", // 保持红色危险按钮样式
            cancelButtonText: "取消", // 补充取消按钮文本，体验更清晰
            customClass: "logout-confirm-modal",
            closeOnClickModal: false // 点击弹窗外部不关闭，避免误操作
        }).then(() => {
            // 1. 调用后端退出接口（确保后端销毁会话）
            newService.logout().then(() => {
                // 2. 彻底清除登录相关数据（避免残留信息）
                // 清除 Token（Cookie + 本地存储）
                this.$cookies.remove(config.TOKEN);
                this.$TOOL.data.remove(config.TOKEN);
                // 清除用户信息（如个人信息、权限标识等，根据项目实际存储位置补充）
                this.$TOOL.data.remove("USER_INFO"); // 清除用户信息
                this.$TOOL.data.remove("IS_PRIMARY_TENANT"); // 清除管理员标识
                this.$store.commit("user/updateUser", null); // 清空 Vuex 中的用户状态
                this.$TOOL.data.remove("TODO_VAL"); // 清除消息弹框控制标识
                window.location.reload()
            }).catch((error) => {
                // 接口调用失败处理（如网络错误）
                this.$message.error("退出接口调用失败，请重试");
                console.error("Logout API error:", error);
            });
        }).catch(() => {
            // 取消退出：可补充取消提示（可选，根据需求决定是否显示）
            this.$message.info("已取消退出操作");
        });
    },
    scrolling(){
      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      if(scrollTop>100){
        if(!this.isbackgrounds){
          this.isbgff=true
        }
        if(this.iscolors && !this.isbackgrounds){
          this.iscolors=false
        }
        if(this.islogoreds && !this.isbackgrounds){
          this.islogoreds=false
        }
        this.isboxshow=true
        // if(this.$store.state.iscolor){
        //   this.$store.state.iscolor=false
        // }
      }else{
        this.isbgff=false
        this.isboxshow=false
        this.iscolors=this.$store.state.iscolor
        this.islogoreds=this.$store.state.islogored
      }
      this.calcWrapPosition();
    },
    navclick(val){
      // console.log(this.isnavtext,val.name)
      this.isnavtext=val.name
      this.$store.state.components=val.title
      this.$store.state.isbackground=false
      this.$store.state.iscolor=false
      this.$store.state.islogored=false
      document.body.scrollTop=document.documentElement.scrollTop=0
    // this.$emit('navclick',val)
    },
    // 开外链
    openlinke(val){
      if(val.title!==undefined){
        this.navclick(val)
      }else{
        this.$emit('workclick',val)
        // window.open(val.url, "_self");
      }

    }
  },

}
</script>

<style scoped>

/* 强制修改弹窗样式，提高优先级 */
.el-message-box.logout-confirm-modal {
    width: 600px !important;
    min-height: 200px !important;
}

/* 标题样式 */
.el-message-box.logout-confirm-modal .el-message-box__title {
    font-size: 24px !important;
    margin-bottom: 20px !important;
}

/* 提示内容样式 */
.el-message-box.logout-confirm-modal .el-message-box__content {
    font-size: 20px !important;  /* 显著增大提示文字 */
    padding: 30px 20px !important;
    line-height: 1.8 !important;
}

/* 按钮区域样式 */
.el-message-box.logout-confirm-modal .el-message-box__btns {
    padding: 20px !important;
}

/* 按钮文字样式 */
.el-message-box.logout-confirm-modal .el-button {
    font-size: 18px !important;
    padding: 10px 25px !important;
    margin: 0 10px !important;
}
.wrap{
  width: 140rem;
  margin: auto;
  display: flex;
  min-width: 120rem;
}
.fixheader{
  height: 6.4rem;
  line-height: 6.4rem;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  min-width: 120rem;
  color: #000;

}
.boxshow{box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.1);}
.bgred{
  background: #fff;
/*  background: linear-gradient(90deg, #C81C22 0%, #D32129 100%);*/
}
.bgfff{
  background: #fff;
}
.tcolor{
  box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.1);
  /*color:#fff ;*/
}
.logo img{
  height: 2.7rem;
  margin:2rem 3rem 2rem 0rem;
}
nav{
  flex: 1;
}
.navtitle{
  padding: 0 1rem;
  margin: 0 1rem;
  cursor: pointer;
  position: relative;
  display: inline-block;
  font-size: 1.6rem;
  font-weight: 500;
}
.ewlink {
/*margin-right: 12rem;*/
}
.ewlink span{
  padding: 0 1rem;
  margin: 0 1rem;
  cursor: pointer;
  position: relative;
  display: inline-block;
  font-size: 1.6rem;
  font-weight: 500;
}
.navtitle:hover::after,.action::after,.ewlink span:hover::after{
  position: absolute;
  content: '';
  height: 0.2rem;
  left: 30%;
  bottom:20%;
  width: 40%;
  background: #FF0B41;
}
.tcolor .navtitle:hover::after,.tcolor .action::after,.tcolor .ewlink span:hover::after{
  position: absolute;
  content: '';
  height: .2rem;
  left: 30%;
  bottom:20%;
  width: 40%;
  background: #FF0B41;
}
/* 用户下拉菜单样式 */
.contact-section {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.user-dropdown {
  margin-left: 30px;
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-name {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
}

/* 下拉菜单样式调整 */
:deep(.el-dropdown-menu) {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
}

:deep(.el-dropdown-menu__item i) {
  margin-right: 8px;
  font-size: 16px;
}

:deep(.el-dropdown-menu__item:hover) {
  background-color: #f5f7fa;
  color: #FF0B41;
}

:deep(.el-dropdown-menu__item:active) {
  background-color: #ecf5ff;
}
</style>
